import React from 'react';
import { PieChart } from 'lucide-react';
import { SectionHeader } from './SectionHeader';

// Content Distribution Component
export function ContentDistribution({ filteredContentStats, dateRangeLabel }) {
  return (
    <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))] rounded-xl overflow-hidden">
      <SectionHeader icon={PieChart} title="Content Distribution" subtitle={`Post type breakdown • ${dateRangeLabel}`} />
      
      <div className="p-5">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
          <div className="bg-[#8B5CF6]/10 rounded-lg p-3 text-center border border-[#8B5CF6]/20">
            <p className="text-[10px] uppercase tracking-wider text-[#6B7280] mb-1">PHOTO</p>
            <p className="text-xl font-bold text-[#8B5CF6]">{filteredContentStats.photo}</p>
            <p className="text-[10px] text-[#6B7280]">{filteredContentStats.total > 0 ? Math.round(filteredContentStats.photo / filteredContentStats.total * 100) : 0}%</p>
          </div>
          <div className="bg-[#EC4899]/10 rounded-lg p-3 text-center border border-[#EC4899]/20">
            <p className="text-[10px] uppercase tracking-wider text-[#6B7280] mb-1">VIDEO</p>
            <p className="text-xl font-bold text-[#EC4899]">{filteredContentStats.video}</p>
            <p className="text-[10px] text-[#6B7280]">{filteredContentStats.total > 0 ? Math.round(filteredContentStats.video / filteredContentStats.total * 100) : 0}%</p>
          </div>
          <div className="bg-[#06B6D4]/10 rounded-lg p-3 text-center border border-[#06B6D4]/20">
            <p className="text-[10px] uppercase tracking-wider text-[#6B7280] mb-1">TEXT</p>
            <p className="text-xl font-bold text-[#06B6D4]">{filteredContentStats.text}</p>
            <p className="text-[10px] text-[#6B7280]">{filteredContentStats.total > 0 ? Math.round(filteredContentStats.text / filteredContentStats.total * 100) : 0}%</p>
          </div>
        </div>
        
        {/* Progress bars */}
        <div className="bg-[hsl(var(--surface-elevated))] rounded-lg p-4 border border-[hsl(var(--border))]">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-16 text-xs text-[#6B7280]">Photo</div>
              <div className="flex-1 h-3 bg-[hsl(var(--border))] rounded-full overflow-hidden">
                <div className="h-full bg-[#8B5CF6] rounded-full transition-all" style={{ width: `${filteredContentStats.total > 0 ? (filteredContentStats.photo / filteredContentStats.total * 100) : 0}%` }} />
              </div>
              <span className="text-xs text-white w-12 text-right">{filteredContentStats.total > 0 ? Math.round(filteredContentStats.photo / filteredContentStats.total * 100) : 0}%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-16 text-xs text-[#6B7280]">Video</div>
              <div className="flex-1 h-3 bg-[hsl(var(--border))] rounded-full overflow-hidden">
                <div className="h-full bg-[#EC4899] rounded-full transition-all" style={{ width: `${filteredContentStats.total > 0 ? (filteredContentStats.video / filteredContentStats.total * 100) : 0}%` }} />
              </div>
              <span className="text-xs text-white w-12 text-right">{filteredContentStats.total > 0 ? Math.round(filteredContentStats.video / filteredContentStats.total * 100) : 0}%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-16 text-xs text-[#6B7280]">Text</div>
              <div className="flex-1 h-3 bg-[hsl(var(--border))] rounded-full overflow-hidden">
                <div className="h-full bg-[#06B6D4] rounded-full transition-all" style={{ width: `${filteredContentStats.total > 0 ? (filteredContentStats.text / filteredContentStats.total * 100) : 0}%` }} />
              </div>
              <span className="text-xs text-white w-12 text-right">{filteredContentStats.total > 0 ? Math.round(filteredContentStats.text / filteredContentStats.total * 100) : 0}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentDistribution;
